"use client"

import ControllerWarpper from "@/components/common/ControllerWarpper"
import { useAppDispatch, useAppSelector } from "@/hooks/redux"
import { thunks } from "@/lib/redux/thunks"
import { yupResolver } from "@hookform/resolvers/yup"
import { Form, Input, Modal, notification } from "antd"
import { forwardRef, useCallback, useImperativeHandle, useState } from "react"
import { useForm } from "react-hook-form"
import * as yup from 'yup'

export type ModalContactRef = {
  open: () => void,
  close: () => void
}

const schema = yup.object({
  name: yup.string().required().required("Name is a required field!"),
  email: yup.string().email("Input a valid email please!").required("Email is a required field!"),
  phone: yup.string().required().required("Phone is a required field!"),
  order: yup.string().required().required("Order is a required field!"),
  message: yup.string(),
}).required()

const defaultValues = {
  name: "",
  email: "",
  phone: "",
  order: "",
  message: "",
}

const ModalContact = forwardRef<ModalContactRef, any>((props, ref) => {
  const [open, setOpen] = useState<boolean>(false)
  const form = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValues
  })
  const dispatch = useAppDispatch()
  const sendingEmail = useAppSelector(state => state.store.send_mail_contact.loading)
  const [noti, notiCtx] = notification.useNotification()

  const handleClose = useCallback(() => {
    setOpen(false)
    form.reset(defaultValues)
  }, [])

  const handleOpen = useCallback(() => {
    setOpen(true)
    form.reset(defaultValues)
  }, [])

  useImperativeHandle(ref, () => {
    return {
      open: handleOpen,
      close: handleClose
    }
  }, [handleClose, handleOpen])

  return (
    <Modal
      title="Contact with us"
      open={open}
      okText="Submit"
      onCancel={handleClose}
      onOk={form.handleSubmit((values) => {
        dispatch(thunks.send_mail_contact({
          body: values
        })).unwrap().then(() => {
          noti.success({
            title: "Notification",
            description: "Your request has been submitted successfully!"
          })
        }).catch(() => {
          noti.error({
            title: "Notification",
            description: "There are some thing wrong, please again later!"
          })
        }).finally(() => {
          handleClose()
        })
      })}
      confirmLoading={sendingEmail}
      styles={{
        
      }}
    >
      {notiCtx}
      <Form
        layout='vertical'
      >
        <ControllerWarpper
          name="name"
          control={form.control}
          label="Name"
          required
          render={({ field }) => {
            return (
              <Input {...field} />
            )
          }}
        />

        <ControllerWarpper
          name="email"
          control={form.control}
          label="Email"
          required
          render={({ field }) => {
            return (
              <Input {...field} />
            )
          }}
        />

        <ControllerWarpper
          name="phone"
          required
          control={form.control}
          label="Phone"
          render={({ field }) => {
            return (
              <Input {...field} />
            )
          }}
        />

        <ControllerWarpper
          name="order"
          required
          control={form.control}
          label="Order"
          render={({ field }) => {
            return (
              <Input {...field} />
            )
          }}
        />

        <ControllerWarpper
          name="message"
          control={form.control}
          label="Message"
          render={({ field }) => {
            return (
              <Input.TextArea {...field} />
            )
          }}
        />
      </Form>
    </Modal>
  )
})

export default ModalContact